/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import dropDownTypes from '../../constants/dropDownTypes';

class dropDownMenu extends React.Component {
  constructor(props) {
    super(props);

    this.dropDownElement = React.createRef();
    this.list = null;
  }

  componentDidMount() {
    const { dropDown = {}, disabled = false} = this.props;
    const { elementClicked, closeDropdown } = dropDown;
    const { top, left } = this.getDropdownPosition();
    this.dropDownElement.current.style.top = `${top}px`;
    this.dropDownElement.current.style.left = `${left}px`;

    if (!disabled) {
      window.addEventListener(
        'click',
        evt => {
          const closest = evt.target.closest('.dropdown-component-menu');
          if (evt.target !== elementClicked && !closest) {
            closeDropdown();
          }
        },
        {
          once: true,
          capture: true
        }
      );
    }

    // Check scroll from plan wall to fix dropdown menu accordingly
    this.list =
      dropDown.parent ||
      elementClicked.closest('.virtualized-container-list') ||
      elementClicked.closest('#scrollable-wall-container');
    if (this.list) {
      this.list.addEventListener('scroll', this.setPositionBasedOnScroll, {
        passive: true
      });
    }
  }

  componentWillUnmount() {
    if (this.list) {
      this.list.removeEventListener('scroll', this.setPositionBasedOnScroll);
    }
  }

  setPositionBasedOnScroll = e => {
    const parentRect = e.target.getBoundingClientRect();
    const { top: parentTop, bottom: parentBottom } = parentRect;
    const { top, left, bottom } = this.getDropdownPosition();
    if (top < parentTop || bottom > parentBottom) {
      const { dropDown = {} } = this.props;
      dropDown.closeDropdown();
      return;
    }
    this.dropDownElement.current.style.top = `${top}px`;
    this.dropDownElement.current.style.left = `${left}px`;
  };

  getDropdownPosition = () => {
    const { dropDown } = this.props;
    const { elementAttached: element } = dropDown;
    // Parent where dropdown is
    const parent =
      dropDown.parent ||
      document.getElementById('scrollable-wall-container') ||
      document.documentElement;
    const parentRect = parent.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    const dropDownWidth = this.dropDownElement.current.clientWidth;
    const dropDownHeight = this.dropDownElement.current.clientHeight;
    let top = elementRect.top + element.clientHeight;
    // eslint-disable-next-line
    let { left, bottom } = elementRect;

    // In case of dropdown menu overflow the page width/height loads it at the
    // left/top side of the element that triggered it
    if (
      parentRect.right > 0 &&
      element.getBoundingClientRect().left + dropDownWidth > parentRect.right &&
      element.getBoundingClientRect().left - dropDownWidth > parentRect.left
    ) {
      left -= dropDownWidth - element.clientWidth;
    }
    if (
      parentRect.bottom > 0 &&
      element.getBoundingClientRect().top + dropDownHeight >
        parentRect.bottom &&
      element.getBoundingClientRect().top - dropDownHeight > parentRect.top
    ) {
      top -= dropDownHeight + element.clientHeight;
    }

    return {
      left,
      top,
      bottom
    };
  };

  render() {
    const { type, dropDown } = this.props;
    const DropDownComponent =
      dropDownTypes[type] && dropDownTypes[type].component;
    return DropDownComponent ? (
      <div
        className="dropdown-component-menu"
        ref={this.dropDownElement}
        style={{
          position: 'fixed',
          zIndex: 9999
        }}
        onClick={dropDown.closeDropdown}
      >
        <DropDownComponent {...dropDown} />
      </div>
    ) : null;
  }
}

dropDownMenu.propTypes = {
  type: PropTypes.string.isRequired,
  dropDown: PropTypes.object.isRequired,
  disabled: PropTypes.bool
};

export default dropDownMenu;
